import { css } from '@emotion/css';

import { Colors, Spacing } from 'apps/shared/scripts/styles/constants';

export const cardPreviewClassName = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});

export const containerClassName = css({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  marginTop: Spacing.XL,
  marginBottom: Spacing.XL,
  paddingLeft: Spacing['3XL'],
  paddingRight: Spacing['3XL'],
});

export const browserClassName = css({
  background: Colors.White,
  borderRadius: 12,
  boxShadow:
    '0px 0px .5px rgba(0, 0, 0, .08), 0px 10px 24px rgba(0, 0, 0, .18), 0px 2px 5px rgba(0, 0, 0, .15)',
  maxHeight: 520,
  maxWidth: 800,
  overflow: 'hidden',
  position: 'relative',
  height: '100%',
  width: '100%',
});
